export default __webpack_public_path__ + "static/media/gallery-wip-pommel_00.8b348cc5.jpg";